import { useState, useCallback } from "react";
import { DropdownMenu } from "@/components/shared/dropdown-menu";
import { Button, Flex, Table, Text } from "@radix-ui/themes";
import { DotsVerticalIcon, Pencil1Icon, TrashIcon } from "@radix-ui/react-icons";
import { SubTopic } from "@/v2/entities/subtopic/SubTopic.model";
import { EditSubTopicDialog } from "./EditSubTopicDialog";
import { DeleteSubTopicDialog } from "./DeleteSubTopicDialog";
import { Dialog } from "@/components/shared/dialog";

interface SubTopicItemProps {
  subTopic: SubTopic;
  onSuccess: () => void;
}

export function SubTopicItem({ subTopic, onSuccess }: SubTopicItemProps) {
  const [editOpen, setEditOpen] = useState(false);
  const [deleteOpen, setDeleteOpen] = useState(false);

  const handleEdit = useCallback(() => {
    setEditOpen(true);
  }, []);

  const handleDelete = useCallback(() => {
    setDeleteOpen(true);
  }, []);

  const handleEditSuccess = useCallback(() => {
    setEditOpen(false);
    onSuccess();
  }, [onSuccess]);

  const handleDeleteSuccess = useCallback(() => {
    setDeleteOpen(false);
    onSuccess();
  }, [onSuccess]);

  return (
    <Table.Row>
      <Table.Cell>
        <Text size="2">{subTopic.name}</Text>
      </Table.Cell>
      <Table.Cell>
        <Flex justify="end">
          <DropdownMenu
            items={[
              {
                label: "Edit",
                icon: <Pencil1Icon />,
                onClick: handleEdit,
              },
              {
                label: "Delete",
                icon: <TrashIcon />,
                onClick: handleDelete,
              },
            ]}
          >
            <DropdownMenu.Trigger>
              <Button variant="ghost" size="1">
                <DotsVerticalIcon />
              </Button>
            </DropdownMenu.Trigger>
          </DropdownMenu>
        </Flex>
      </Table.Cell>

      <Dialog open={editOpen} onOpenChange={setEditOpen}>
        <EditSubTopicDialog
          subTopic={subTopic}
          onSuccess={handleEditSuccess}
          onCancel={() => setEditOpen(false)}
        />
      </Dialog>

      <Dialog open={deleteOpen} onOpenChange={setDeleteOpen}>
        <DeleteSubTopicDialog
          subTopic={subTopic}
          onSuccess={handleDeleteSuccess}
          onCancel={() => setDeleteOpen(false)}
        />
      </Dialog>
    </Table.Row>
  );
}
